import {GeneralAction, UserPayload} from '../../../@types/actions';
import {LIVE_INITIALIZE} from '../../../constants/LiveConstants';

export const GetInitAction = (userId: string): GeneralAction<UserPayload> => ({
    type: LIVE_INITIALIZE,
    payload: {userId}
});
